const translations = {
    back: 'Back',
    next: 'Next'
};

export default translations;
